import React from 'react';
import { HeartIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-spiritual-900 border-t border-spiritual-800 py-8 px-5 md:px-8" data-id="element-18">
      <div className="max-w-7xl mx-auto text-center" data-id="element-19">
        <p className="text-spiritual-300/40 font-body text-sm mb-2" data-id="element-20">
          Código de Sanación del Árbol © {new Date().getFullYear()} · Todos los
          derechos reservados
        </p>
        <p className="text-spiritual-300/30 font-body text-xs flex items-center justify-center gap-1" data-id="element-21">
          Hecho con{' '}
          <HeartIcon className="w-3 h-3 fill-spiritual-400/50 text-spiritual-400/50" aria-hidden="true" data-id="element-22" />{' '}
          para tu sanación
        </p>
        <div className="mt-4 flex items-center justify-center gap-4" data-id="element-23">
          <span className="text-spiritual-300/20 font-body text-xs" data-id="element-24">
            Producto digital · Descarga inmediata
          </span>
        </div>
        <div className="mt-4 flex items-center justify-center gap-3 flex-wrap" data-id="element-25">
          <a href="#politicas" className="text-spiritual-300/40 hover:text-spiritual-300/70 font-body text-xs underline underline-offset-2 transition-colors" data-id="element-26">
            Políticas de Privacidad
          </a>
          <span className="text-spiritual-300/20 text-xs" data-id="element-27">·</span>
          <a href="#terminos" className="text-spiritual-300/40 hover:text-spiritual-300/70 font-body text-xs underline underline-offset-2 transition-colors" data-id="element-28">
            Términos y Condiciones
          </a>
          <span className="text-spiritual-300/20 text-xs" data-id="element-29">·</span>
          <a href="#responsabilidad" className="text-spiritual-300/40 hover:text-spiritual-300/70 font-body text-xs underline underline-offset-2 transition-colors" data-id="element-30">
            Descargo de Responsabilidad
          </a>
        </div>
        <p className="mt-3 text-spiritual-300/20 font-body text-[10px] max-w-2xl mx-auto leading-relaxed" data-id="element-31">
          Este producto es de carácter informativo y educativo. Los resultados
          pueden variar según cada persona. No sustituye el consejo de un
          profesional de salud mental o financiero.
        </p>
      </div>
    </footer>;
}